// src/services/userRequestService.ts
import { apiService } from './api';

export interface PersonData {
  PersonID: number;
  Name: string;
  Email: string;
  ConfigValueID: number;
  IsEnabled: boolean;
}

export interface GroupSecurityGroup {
  GroupId: number;
  SecurityGroupId: number;
  Name: string;
}

export interface GroupLayer {
  GroupId: number;
  LayerId: number;
  Name: string;
  Color: string;
  IsEnabled: boolean;
  IsDefault: boolean;
}

export interface Group {
  GroupId: number;
  Name: string;
  Description: string | null;
  IsDeleted: boolean;
  IsDefault: boolean;
  GroupPersons: null;
  GroupLayers: GroupLayer[];
  GroupSecurityGroups: GroupSecurityGroup[];
}

export interface PeopleMember {
  PersonID: number;
  Name: string;
  IsEnabled: boolean;
  IsAdminProject: boolean;
  External: boolean;
  SecurityGroupID: number;
  Status: boolean;
  EmailAddress: string;
  SecurityGroups: GroupSecurityGroup[];
}

export interface ApproveUserPayload {
  PersonID: string;
  ConfigValueID: number;
  Email: string;
  SecurityGroups: Array<{
    GroupId: number;
    GroupName: string;
    Name: string;
    SecurityGroupId: number;
  }>;
  DefaultGroup: Group & {
    SelectedSubGroup: GroupSecurityGroup | null;
  };
}

const userRequestService = {
  getPersonById: (personId: number): Promise<PersonData> =>
    apiService.get<PersonData>(`Person/GetPersonById?personId=${personId}`),

  getPeopleGroups: (): Promise<PeopleMember[]> =>
    apiService.get<PeopleMember[]>('security/getpeoplegroups'),

  getGroups: (): Promise<Group[]> => apiService.get<Group[]>('group/GetGroups?getAllGroups=true'),

  approveUser: (payload: ApproveUserPayload): Promise<string> =>
    apiService.put<string>('person/approveuser', payload),
};

export default userRequestService;
